import { db, docsFromSnapshot } from "../firebase";
import _ from "lodash";

const state = {
  plans: {}
};

const getters = {
  plans: state => state.plans,
  plansList: state => _.sortBy(state.plans, "sortWeight")
};

const actions = {
  async fetchPlans(context) {
    const snapshot = await db.collection("plans").get();
    context.commit("setPlans", docsFromSnapshot(snapshot));
  }
};

const mutations = {
  setPlans(state, plans) {
    state.plans = plans;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
